import { Badge } from "react-bootstrap";
import { getCategoryTypeName } from "../../../Categories/utils/category.utils";
import {
  formatCategoryCc,
  getCategorySelectValue,
  getRallyCategories,
  getRallyCategoryLabel,
  getRallyPricingMap,
} from "../../utils/rally.utils";

const RallyCategorySection = ({ rally }) => {
  const categories = getRallyCategories(rally);
  const pricingMap = getRallyPricingMap(rally);

  return (
    <div className="mb-4">
      <h5 className="mb-3">Categories & pricing ({categories.length})</h5>

      {!categories.length ? (
        <p className="text-muted mb-0">
          No categories assigned to this rally.
        </p>
      ) : (
        <div className="table-responsive border rounded">
          <table className="table table-striped mb-0 align-middle">
            <thead className="table-light">
              <tr>
                <th>#</th>
                <th>Category</th>
                <th>Type</th>
                <th>CC</th>
                <th>Max members</th>
                <th>Codriver</th>
                <th>Price</th>
              </tr>
            </thead>
            <tbody>
              {categories.map((category, index) => {
                const isObject = category && typeof category === "object";
                const title = getRallyCategoryLabel(category) || "-";
                const key = getCategorySelectValue(category);
                const price =
                  pricingMap[key] ??
                  pricingMap[
                    isObject ? category._id || category.id : category
                  ] ??
                  "-";

                return (
                  <tr key={`${key || title}-${index}`}>
                    <td>{index + 1}</td>
                    <td>
                      <div className="fw-semibold">{title}</div>
                      {isObject && category.key && category.key !== title ? (
                        <Badge bg="secondary" className="mt-1">
                          {category.key}
                        </Badge>
                      ) : null}
                    </td>
                    <td>
                      {isObject ? getCategoryTypeName(category) || "-" : "-"}
                    </td>
                    <td>{isObject ? formatCategoryCc(category) : "-"}</td>
                    <td>
                      {isObject
                        ? category.max_members === 0 || category.max_members
                          ? category.max_members
                          : "-"
                        : "-"}
                    </td>
                    <td>
                      {isObject
                        ? category.navigator_allowed
                          ? "Yes"
                          : "No"
                        : "-"}
                    </td>
                    <td>{price === 0 || price ? String(price) : "-"}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default RallyCategorySection;
